var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cube-rate-item",class:{ 'cube-rate-item_active': _vm.index <= _vm.$parent.tempValue }},[_vm._t("default",function(){return [_c('div',{staticClass:"cube-rate-item-def"})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3671e522","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_cube-ui@1.12.47@cube-ui/src/components/rate/rate-item.vue
// module id = null
// module chunks = 